import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DownloadRequestService } from '@core/services/download-request.service';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-download-demographics-scores',
    templateUrl: './download-demographics-scores.component.html',
    styleUrls: ['./download-demographics-scores.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DownloadDemographicsScoresComponent implements OnInit {
  downloadService = inject(DownloadRequestService);
  dialog = inject(MatDialog);
  route = inject(ActivatedRoute);
  is2025: boolean = false;
  title: string = '';
  
  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.is2025 = this.route.snapshot.data['is2025'] ?? false;
    this.title = this.translocoService.translate('downloads.scores.title', {
      year: this.is2025 ? '2025' : '2015',
    });
  }

  downloadDemographics(searchValues: any) {
    const service = (payload: any) => 
      this.is2025
        ? this.downloadService.saveRequestForScores2025(payload)
        : this.downloadService.saveRequestForScores(payload);
    
    service(searchValues)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.displaySuccessMessage();
        }
      });
  }

  displaySuccessMessage() {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('downloads.requestSubmitted.title'),
          message: this.translocoService.translate(
            'downloads.requestSubmitted.message'
          ),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('downloads.requestSubmitted.okButton'),
          showCancel: false,
        },
      },
    };

    this.dialog.open(ConfirmationModalComponent, {
      data: modal,
    });
  }
}
